AGA.Page = (function () {

    var hideEmptyGroups = function () {
        var groupsToCheck = [];

        $(".tab-pane.hidden").each(function () {
            var tabId = $(this).attr("id");
            var widgetId = tabId.substring(3);
            var li = $("li.aga-li[data-widget-id='" + widgetId + "']");
            if (!$(li).is(".hidden")) {
                $(li).addClass("hidden");

                // Se o parent é um agrupamento adiciona para verificar depois
                if ($(li).parent().is(".aga-tab-dropdown")) {
                    groupsToCheck.push($(li).parent().parent().get(0));
                }
            }
        });

        // Desocultar li e grupos se tab-pane for desocultado
        $(".tab-pane:not(.hidden)").each(function () {
            var tabId = $(this).attr("id");
            var widgetId = tabId.substring(3);
            var li = $("li.aga-li[data-widget-id='" + widgetId + "']");
            if ($(li).hasClass("hidden")) {
                $(li).removeClass("hidden");
                if ($(li).parent().hasClass("aga-tab-dropdown")) {
                    $(li).parent().parent().removeClass("hidden");
                }
            }
        });

        // Verificar se algum grupo ficou vazio
        groupsToCheck = $.unique(groupsToCheck);
        $.each(groupsToCheck, function () {
            if ($(this).find("li:not(.hidden)").length === 0) {
                $(this).addClass("hidden");
            } else {
                $(this).removeClass("hidden");
            }
        });
    };

    var observeTabPaneChanges = function () {
        var observer = new MutationObserver(function (mutationsList) {
            var relevant = false;
            mutationsList.forEach(function (mutation) {
                if (mutation.type === "attributes" && mutation.attributeName === "class") {
                    relevant = true;
                }
            });
            if (relevant) {
                hideEmptyGroups();
            }
        });

        $(".tab-pane").each(function () {
            observer.observe(this, { attributes: true, attributeFilter: ["class"] });
        });
    };

    var internalInit = function () {
        setTimeout(function () {
            hideEmptyGroups();
            observeTabPaneChanges();
        }, 1);
    };

    return {
        init: function () {
            internalInit();
        }
    };

})();